import { isMobile } from "../utils/breakpoints"

$(function () {
  $(window).on("click", () => {
    $(".modernize-dropdown").addClass("hidden")
  })

  $(".modernize-dropdown-trigger").on("click", (e) => {
    e.stopPropagation()

    const $trigger = $(e.currentTarget)
    const $dropdown = $("#" + $trigger.data("target"))
    let direction = $trigger.data("direction-desktop")

    if (isMobile()) {
      direction = $trigger.data("direction-mobile")
    }

    if ($dropdown.hasClass("hidden")) {
      $dropdown.removeClass("hidden")
    } else {
      $dropdown.addClass("hidden")
    }

    let top
    let left

    if (direction === "top-left") {
      top = $trigger.position().top - 5 - $dropdown.outerHeight(true)
      left = $trigger.position().left + $trigger.outerWidth(true) - $dropdown.outerWidth(true)
    } else if (direction === "bottom-left") {
      top = $trigger.position().top + $trigger.outerHeight(true) + 5
      left = $trigger.position().left + $trigger.outerWidth(true) - $dropdown.outerWidth(true)
    } else if (direction === "bottom-right") {
      top = $trigger.position().top + $trigger.outerHeight(true) + 5
      left = $trigger.position().left
    }

    $dropdown.css({ left, top })
  })
})
